<main class="main home-page skeleton-body">
    <div class="intro-slider-container">
        <owl-carousel carouselClasses="owl-simple intro-slider" [options]="introSlider">
            <div class="intro-slide"
                style="background-image: url(assets/images/home/carosello/hero-chi-siamo.jpg); background-color: #EDF2F0;">
                <div class="container intro-content" contentAnim aniName="fadeInUpShorter">
                    <div class="row">
                        <div class="col-auto">
                            <div class="text-black bg-white p-4 pr-5 mb-2">
                                <h6 class="text-primary">ACCENDI LA TUA IDEA DI LUCE</h6>
                                <h1 class="title-banner-home">
                                    LED e componenti per insegne,<br>impianti e light design
                                </h1>
                                <a routerLink="/shop" class="btn btn-primary mt-2">
                                    <span>Scopri tutti i prodotti</span>
                                    <i class="icon-long-arrow-right"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="intro-slide"
                style="background-image: url(assets/images/home/carosello/hero-flex.jpg); background-color: #edf1f0;">
                <div class="container intro-content" contentAnim aniName="fadeInUpShorter">
                    <div class="row">
                        <div class="col-auto">
                            <div class="text-black bg-white p-4 mb-2">
                                <h4>CONFIGURATORE</h4>
                                <h1>
                                    scritte luminose effetto
                                    <br /><span class="text-primary">neon</span>
                                </h1>
                            </div>
                            <a href="https://configura.scritteluminose.com" class="btn btn-primary" target="_blank"
                                rel="noopener noreferrer">
                                <span>Scopri</span>
                                <i class="icon-long-arrow-right"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="intro-slide"
                style="background-image: url(assets/images/home/carosello/hero-promo.jpg); background-color: #ffffff;">
                <div class="container intro-content" contentAnim aniName="fadeInUpShorter">
                    <div class="row">
                        <div class="col-auto">
                            <div class="text-black bg-white p-4 mb-2">
                                <h4>SCOPRI TUTTI I PRODOTTI</h4>
                                <h1>IN PROMOZIONE</h1>
                            </div>
                            <a [routerLink]="['/shop/sidebar/3cols']" [queryParams]="{ searchTerm: 'promo' }"
                                class="btn btn-outline-light">
                                <span>VAI ALLO SHOP</span>
                                <i class="icon-long-arrow-right"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </owl-carousel>
    </div>

    <div class="mb-4"></div>

    <div class="container">
        <h2 class="title text-center mb-2" contentAnim aniName="blurIn">Tutte le nostre categorie prodotto</h2>
        <div class="cat-blocks-container">
            <div class="row justify-content-md-center">
                <div class="col-lg-2 col-md-3 col-sm-4 col-6" *ngFor="let item of categories;">
                    <a routerLink="/shop/sidebar/3cols" [queryParams]="{category: item.CategoriaId}" class="cat-block">
                        <figure>
                            <span>
                                <img [src]="item.Immagine1" [alt]="item.Descrizione" [title]="item.Descrizione"
                                    class="mb-1">
                            </span>
                        </figure>
                        <h3 class="cat-block-title">{{ item.Descrizione }}</h3>
                    </a>
                </div>
            </div>
        </div>
    </div>

    <div class="mb-2"></div>

    <div class="container">
        <div class="row justify-content-center">

            <div class="col-sm-12 col-md-6">
                <div class="banner banner-3 banner-overlay" style="background-color: #465d55;" contentAnim
                    aniName="fadeInLeft">
                    <a [routerLink]="['shop/sidebar/list']" [queryParams]="{searchTerm: 'promo'}">
                        <molla-image src="assets/images/home/banners/promo-home.jpg" alt="Articoli in promozione"
                            width="575" height="260"></molla-image>
                    </a>
                    <div class="banner-content w-75">

                        <div class="banner-title">
                            <div class="bg-white p-3">
                                <a [routerLink]="['shop/sidebar/list']" [queryParams]="{searchTerm: 'promo'}">
                                    Articoli<br>in promozione
                                </a>
                            </div>
                        </div>

                        <a [routerLink]="['shop/sidebar/list']" [queryParams]="{searchTerm: 'promo'}"
                            class="banner-link bg-white text-black">
                            Shop Now
                            <i class="icon-long-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-6">
                <div class="banner banner-1 banner-overlay" style="background-color: #ebebeb;" contentAnim
                    aniName="fadeInRight">
                    <a routerLink="/product/default/03.17.40.05.94.00001/posterled-p1.8-da-interno-640x1920-mm-800cd">
                        <molla-image src="assets/images/home/banners/poster-home.jpg" alt="POSTERLED" width="575"
                            height="260"></molla-image>
                    </a>
                    <div class="banner-content w-75">

                        <div class="banner-title">
                            <div class="bg-white p-3">
                                <a
                                    routerLink="/product/default/03.17.40.05.94.00001/posterled-p1.8-da-interno-640x1920-mm-800cd">
                                    <span><small>Nuovo display led da interno</small></span>
                                    <br />
                                    POSTERLED
                                </a>
                            </div>
                        </div>

                        <a routerLink="/product/default/03.17.40.05.94.00001/posterled-p1.8-da-interno-640x1920-mm-800cd"
                            class="banner-link bg-white text-black">
                            Shop Now
                            <i class="icon-long-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-lg-12 order-lg-last">
                <div class="banner banner-2 banner-overlay" style="background-color: #d28679;" contentAnim
                    aniName="fadeInUpShorter">
                    <a href="https://configura.scritteluminose.com" target="_blank" rel="noopener noreferrer">
                        <molla-image src="assets/images/home/banners/flex-home.jpg" alt="Tuboflex" width="1168"
                            height="260"></molla-image>
                    </a>
                    <div class="banner-content">

                        <h3 class="banner-title text-white">
                            <a href="https://configura.scritteluminose.com/" target="_blank" rel="noopener noreferrer">
                                Configura la tua insegna in Tuboflex
                                <br />
                                <span> Scegli colore, dimensioni e visualizza subito il costo</span>
                            </a>
                        </h3>

                        <a href="https://configura.scritteluminose.com/" target="_blank"
                            class="banner-link bg-primary p-3" rel="noopener noreferrer">
                            Calcola il prezzo
                            <i class="icon-long-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="mb-3"></div>

    <molla-products-collection *ngIf="prodColl2.length > 0" [products]="prodColl2" [loaded]="loaded2"
        [titolo]="'Strip Led'">
    </molla-products-collection>


    <div class="mb-3"></div>

    <molla-products-collection *ngIf="prodColl4.length > 0" [products]="prodColl4" [loaded]="loaded4"
        [titolo]="'Controller'">
    </molla-products-collection>

    <div class="mb-5"></div>

    <div class="container">
        <hr>
        <div class="mb-5"></div>
        <div class="row">
            <div class="col-lg-6 col-md-12">
                <img src="./../../../../assets/images/home/banners/esperti_illuminazione_led.png"
                    title="Esperti di illuminazione LED per il mondo professionale">
            </div>
            <div class="col-lg-6 col-md-12 custom-padding">
                <h4>Esperti di illuminazione LED per il mondo professionale.</h4>
                <p>My Lite Led nasce dall’unione di oltre 30 anni di esperienza nel settore della comunicazione luminosa
                e una forte specializzazione nella tecnologia LED.
                Dal 2009 selezioniamo e distribuiamo prodotti per l’illuminazione e materiali elettrici destinati a
                professionisti.
                </p><br>
                <p>Siamo un punto di riferimento per chi cerca qualità, affidabilità e convenienza in un unico shop.
                Ogni articolo è scelto con cura per garantire performance, durata e coerenza con le ultime
                evoluzioni del mercato.
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-md-12 custom-padding d-none d-md-block">
                <h4>Un’illuminazione efficiente e sostenibile.</h4>
                <p>Il nostro catalogo è orientato a prodotti a basso consumo e soluzioni
                tecnologiche capaci di ridurre sprechi e impatto ambientale.
                </p><br>
                <p>Il nostro impegno quotidiano: rendere l’acquisto di LED professionali semplice, veloce e
                consapevole.<br>
                Crediamo che il lavoro, come la vita, sia un viaggio verso il miglioramento: un percorso fatto di
                crescita, attenzione e scelte responsabili.</p>
            </div>
            <div class="col-lg-6 col-md-12">
                <img src="./../../../../assets/images/home/banners/illuminazione_efficiente_sostenibile.png" title="Un’illuminazione efficiente e sostenibile.">
            </div>
            <div class="col-lg-6 col-md-12 custom-padding d-block d-md-none">
                <h4>Un’illuminazione efficiente e sostenibile.</h4>
                <p>Il nostro catalogo è orientato a prodotti a basso consumo e soluzioni
                tecnologiche capaci di ridurre sprechi e impatto ambientale.
                </p><br>
                <p>Il nostro impegno quotidiano: rendere l’acquisto di LED professionali semplice, veloce e
                consapevole.<br>
                Crediamo che il lavoro, come la vita, sia un viaggio verso il miglioramento: un percorso fatto di
                crescita, attenzione e scelte responsabili.</p>
            </div>
        </div>
        <div class="mb-5"></div>
    </div>

    <div class="container">
        <h2 class="title title-border mb-3" contentAnim aniName="blurIn">
            Qualità e <span class="text-primary">Sicurezza</span></h2>
        <owl-carousel carouselClasses="brands-border owl-simple brand-slider mb-3" [options]="brandSlider">
            <a href="javascript:;" class="brand">
                <img src="assets/images/quality-regulatory/logo-ce.jpg" alt="CE">
            </a>

            <a href="javascript:;" class="brand">
                <img src="assets/images/quality-regulatory/logo-cree.jpg" alt="CREE">
            </a>

            <a href="javascript:;" class="brand">
                <img src="assets/images/quality-regulatory/logo-enec.jpg" alt="ENEC">
            </a>

            <a href="javascript:;" class="brand">
                <img src="assets/images/quality-regulatory/logo-lg.jpg" alt="LG Innotek">
            </a>

            <a href="javascript:;" class="brand">
                <img src="assets/images/quality-regulatory/logo-mean-well.jpg" alt="MW">
            </a>

            <a href="javascript:;" class="brand">
                <img src="assets/images/quality-regulatory/logo-osram.jpg" alt="OSRAM">
            </a>

            <a href="javascript:;" class="brand">
                <img src="assets/images/quality-regulatory/logo-rohs.jpg" alt="RoHS">
            </a>

            <a href="javascript:;" class="brand">
                <img src="assets/images/quality-regulatory/logo-ru.jpg" alt="RU">
            </a>
        </owl-carousel>
    </div>

    <div class="cta cta-horizontal cta-horizontal-box bg-primary">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-2xl-5col col-12" contentAnim aniName="fadeInLeftShorter">
                    <h3 class="cta-title text-white">Join Our Newsletter</h3>

                    <p class="cta-desc text-white">Iscriviti per restare aggiornato e ricevere promozioni</p>
                </div>

                <div class="col-3xl-5col col-12" contentAnim aniName="fadeInRightShorter">
                    <form [formGroup]="joinForm" (submit)="joinSend()">
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="email"
                                [placeholder]="'fld.email' | translate" [attr.aria-label]="'fld.email' | translate" />
                            <div class="input-group-append">
                                <button class="btn btn-outline-white-2" type="submit">
                                    <span>{{ "btn.subscribe" | translate | uppercase }}</span>
                                    <i class="icon-long-arrow-right"></i>
                                </button>
                            </div>
                        </div>
                        <div *ngIf="submitted && ((joinForm.get('email')?.hasError('required')) || (joinForm.get('email')?.hasError('pattern') && !joinForm.get('email')?.hasError('required')))"
                            class="required">
                            {{ "ctrl.email" | translate }}
                        </div>
                        <!-- Privacy 1: presa visione informativa (obbligatorio) -->
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="nl-privacy1" formControlName="privacy1"
                                (change)="joinForm.get('privacy1')?.updateValueAndValidity()">
                            <label class="custom-control-label" for="nl-privacy1">
                                {{ "privacy.dichiarazione" | translate }}<a [href]="privacyLinks.informativa" target="_blank" rel="noopener noreferrer" style="color: #dddddd;">{{ "privacy.informativa" | translate }}</a>
                            </label>
                        </div>
                        <div *ngIf="submitted && joinForm.get('privacy1')?.hasError('required')" class="required">
                            {{ "ctrl.dichiarazione" | translate }}
                        </div>
 
                        <!-- Privacy 2: finalità commerciali e promozionali -->
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="nl-privacy2" formControlName="privacy2"
                                (change)="joinForm.get('privacy2')?.updateValueAndValidity()">
                            <label class="custom-control-label" for="nl-privacy2">
                                {{ "privacy.consenso" | translate }}<a [href]="privacyLinks.marketing" target="_blank" rel="noopener noreferrer" style="color: #dddddd;">{{ "privacy.informativaMarketing" | translate }}</a>
                            </label>
                        </div>
 
                        <!-- Privacy 3: pixel di tracciamento nelle e-mail (facoltativo) -->
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="nl-privacy3" formControlName="privacy3">
                            <label class="custom-control-label" for="nl-privacy3">
                                {{ "privacy.tracciamento" | translate }}<a [href]="privacyLinks.marketing" target="_blank" rel="noopener noreferrer" style="color: #dddddd;">{{ "privacy.informativaMarketing" | translate }}</a>
                            </label>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <!--molla-blog-collection [posts]="posts" [loaded]="loaded"></molla-blog-collection-->

    <div class="icon-boxes-container bg-white">
        <div class="container" contentAnim aniName="fadeInUpShorter">
            <div class="row">
                <div class="col-sm-6 col-lg-3">
                    <div class="icon-box icon-box-side">
                        <span class="icon-box-icon">
                            <i class="icon-rocket"></i>
                        </span>
                        <div class="icon-box-content">
                            <h3 class="icon-box-title">Spedizione</h3>

                            <p>24h con ordini entro le 12.00</p>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-3">
                    <div class="icon-box icon-box-side">
                        <span class="icon-box-icon">
                            <i class="icon-rotate-left"></i>
                        </span>

                        <div class="icon-box-content">
                            <h3 class="icon-box-title">Reso</h3>

                            <p>Vedi condizioni di reso</p>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-3">
                    <div class="icon-box icon-box-side">
                        <span class="icon-box-icon">
                            <i class="icon-info-circle"></i>
                        </span>

                        <div class="icon-box-content">
                            <h3 class="icon-box-title">Promozioni</h3>

                            <p>Ogni mese articoli in promozione.<br>
                                Consulta l'area ARTICOLI IN PROMOZIONE
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-lg-3">
                    <div class="icon-box icon-box-side">
                        <span class="icon-box-icon">
                            <i class="icon-life-ring"></i>
                        </span>

                        <div class="icon-box-content">
                            <h3 class="icon-box-title">Support</h3>

                            <p>I nostri tecnici sono a disposizione per un consulto telefonico o via mail in orario
                                ufficio</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>